import Immutable from 'seamless-immutable'

const initialState = Immutable({})

export const reducer = (state = initialState, { type, payload }) => state